import React, { useState } from 'react';
import './Forgetpass.css';
import '../../component/layouts/Style.css';


import Helmet from '../../component/Helmet/Helmet';

import { Container, Row, Col } from 'reactstrap';

import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';




const Forgetpass = () => {

  const [message, setMessage] = useState(null);
  
  const handleSubmit = async (e) => {
  e.preventDefault();
  const email = e.target.email.value;

  try {
    const response = await fetch('https://dashboard.tiktaka.com/api/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    const data = await response.json();
    setMessage(data.message);
    // alert(data.message);
  } catch (err) {
    alert("Error sending reset link");
  }
};



  return (
  <Helmet title='Forget Password'>
    <div className="Forgetpass">
   
    <Sidebar/>

    <div className='midSide'>
    <div className='middleSideHome'>
    
    <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='mainSection'>
            <section>
                <Container>
                    <Row>
                        <Col lg='6' md='6' sm='12' className='loginBox'>


                            {/* <Col lg='6' md='6' sm='12' className='loginBox'> */}
                        <form onSubmit={handleSubmit} className='material-form'>
                          <span style={{ color:'red' }} > { message }</span> 
                            <div className='input-field'>
                                <input type='text' placeholder='email' name='email'></input>
                                <label>Email</label>
                                <span className="bar"></span>
                              
                            </div>
                            <button type='submit'>Submit</button>
                        </form>
                        </Col>
                    </Row>
                </Container>
           </section>
        </div>
     {/* End Main Section  */}
    </div>
    </div>
   
   <RightSide/>

  </div>
  </Helmet>
  );
};

export default Forgetpass;